export interface HierarchyNode {
  name: string;
  displayName: string;
  type: 'group' | 'category';
  children?: HierarchyNode[];
  categoryName?: string;
}

// Display name should be match the category names in the API returning from Watchtower
export const SCORECARD_HIERARCHY: HierarchyNode[] = [
  {
    name: 'standardization',
    displayName: 'Standardization',
    type: 'group',
    children: [
      {
        name: 'ownership',
        displayName: 'Ownership',
        type: 'group',
        children: [
          {
            name: 'repository_ownership',
            displayName: 'Repository Ownership',
            type: 'category',
            categoryName: 'Repository Ownership',
          },
          {
            name: 'subscription_ownership',
            displayName: 'Subscription Ownership',
            type: 'category',
            categoryName: 'Subscription Ownership',
          },
        ],
      },
      {
        name: 'jira_compliance',
        displayName: 'Jira Compliance',
        type: 'group',
        children: [
          {
            name: 'investment_category',
            displayName: 'Investment Category',
            type: 'category',
            categoryName: 'Investment Category',
          },
          {
            name: 'orphaned_issues',
            displayName: 'Orphaned Issues',
            type: 'category',
            categoryName: 'Orphaned Issues',
          },
        ],
      },
      {
        name: 'infrastructure_compliance',
        displayName: 'Infrastructure Compliance',
        type: 'group',
        children: [
          {
            name: 'resource_group_tag_',
            displayName: 'Resource Group Tag',
            type: 'category',
            categoryName: 'Resource Group Tag',
          },
        ],
      },
    ],
  },
  {
    name: 'security',
    displayName: 'Security',
    type: 'group',
    children: [
      {
        name: 'infrastructure_security',
        displayName: 'Infrastructure Security',
        type: 'group',
        children: [
          {
            name: 'key_rotation',
            displayName: 'Key Rotation',
            type: 'category',
            categoryName: 'Key Rotation',
          },
          {
            name: 'agent_coverage',
            displayName: 'Agent Coverage',
            type: 'category',
            categoryName: 'Agent Coverage',
          },
          {
            name: 'public_ip',
            displayName: 'Public IP',
            type: 'category',
            categoryName: 'Public IP',
          },
          {
            name: 'privileged_identity',
            displayName: 'Privileged Identity Management',
            type: 'category',
            categoryName: 'Privileged Identity Management',
          },
          {
            name: 'end_of_life',
            displayName: 'End of Life',
            type: 'category',
            categoryName: 'End of Life',
          },
          {
            name: 'vm-vulnerability-compliance',
            displayName: 'VM Vulnerability Compliance',
            type: 'category',
            categoryName: 'VM Vulnerability Compliance',
          },
          {
            name: 'information_classification_compliance',
            displayName: 'Information Classification Compliance',
            type: 'category',
            categoryName: 'Information Classification Compliance',
          },
          {
            name: 'java_sdk_resource',
            displayName: 'Java SDK Resource',
            type: 'category',
            categoryName: 'Java SDK Resource',
          },
        ],
      },
      {
        name: 'code_security',
        displayName: 'Code Security',
        type: 'group',
        children: [
          {
            name: 'blackduck',
            displayName: 'Blackduck Coverage',
            type: 'category',
            categoryName: 'Blackduck Coverage',
          },
          {
            name: 'veracode',
            displayName: 'Veracode Coverage',
            type: 'category',
            categoryName: 'Veracode Coverage',
          },
          {
            name: 'criticality_set',
            displayName: 'Criticality Set',
            type: 'category',
            categoryName: 'Criticality Set',
          },
          {
            name: 'commit_signature_verification',
            displayName: 'Commit Signature Verification',
            type: 'category',
            categoryName: 'Commit Signature Verification',
          },
        ],
      },
    ],
  },
  {
    name: 'cost',
    displayName: 'Cost',
    type: 'group',
    children: [],
  },
  {
    name: 'developer_productivity',
    displayName: 'Developer Productivity',
    type: 'group',
    children: [
      {
        name: 'velocity',
        displayName: 'Velocity',
        type: 'category',
        categoryName: 'Velocity',
      },
    ],
  },
  {
    name: 'developer_experience',
    displayName: 'Developer Experience',
    type: 'group',
    children: [
      {
        name: 'ci_cd_success_rate',
        displayName: 'CI/CD Success Rate',
        type: 'category',
        categoryName: 'CI/CD Success Rate',
      },
      {
        name: 'ktlo',
        displayName: 'KTLO',
        type: 'category',
        categoryName: 'KTLO',
      },
    ],
  },
  {
    name: 'reliability',
    displayName: 'Reliability',
    type: 'group',
    children: [
      {
        name: 'upm',
        displayName: 'UPM',
        type: 'category',
        categoryName: 'UPM',
      },
    ],
  },
];

export const getCategoriesInHierarchy = (): string[] => {
  const categories: string[] = [];

  const traverse = (node: HierarchyNode) => {
    if (node.type === 'category' && node.categoryName) {
      categories.push(node.categoryName);
    }
    if (node.children) {
      node.children.forEach(traverse);
    }
  };

  SCORECARD_HIERARCHY.forEach(traverse);
  return categories;
};
